import {
    createMountsMullionsHorizontalConfig,
    createMountsMullionsVerticalConfig,
} from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSlidingDoorMountsKompasHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);

    const horizontalLinesQty = 1;
    const sides = 2;

    const qty = Math.round(width * horizontalLinesQty * sides) || 0;

    return createMountsMullionsHorizontalConfig()
        .qty(horizontalLinesQty)
        .area(qty)
        .build();
};

const createSlidingDoorMountsKompasVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const height = MountsService.getDoorTotalHeight(partition);

    const verticalLinesQty = 1;
    const sides = 2;

    const qty = Math.round(height * verticalLinesQty * sides) || 0;

    return createMountsMullionsVerticalConfig()
        .qty(verticalLinesQty)
        .area(qty)
        .build();
};

export const KompasNoDoorsConfigs = (partition: Partition) => [
    createSlidingDoorMountsKompasHorizontalConfig(partition),
    createSlidingDoorMountsKompasVerticalConfig(partition),
];
